export default {
  inWebView: function () {
    return (
      (window.webView && typeof window.webView.updateApp === "function") ||
      (window.webkit && typeof window.webkit.messageHandlers["updateApp"] === "object")
    );
  },

  isEcrApp: function () {
    return navigator.userAgent.includes("XBI:org.myesr.ecr");
  },

  setCredentials: function (param) {
    return this._call("setCredentials", param);
  },

  clearBiometricData: function () {
    return this._call("clearBiometricData");
  },

  hasBiometricData: function () {
    return this._call("hasBiometricData");
  },

  updateApp: function () {
    return this._call("updateApp");
  },

  showBiometricPrompt: function () {
    return this._call("showBiometricPrompt");
  },

  setStatusBarColor: function (paramA, paramB) {
    return this._call("setStatusBarColor", paramA, paramB);
  },

  getStatusBarHeight: function () {
    return this._call("getStatusBarHeight");
  },

  _call: function (methodName, paramA = null, paramB = null) {
    // android
    if (window.webView) {
      if (paramA !== null && paramB !== null) {
        return window.webView[methodName](paramA, paramB);
      } else if (paramA !== null) {
        return window.webView[methodName](paramA);
      } else {
        return window.webView[methodName]();
      }
    }
    // iOS
    if (window.webkit) {
      if (window.webkit.messageHandlers === undefined || window.webkit.messageHandlers[methodName] === undefined) {
        return null;
      }
      if (paramA !== null && paramB !== null) {
        return window.webkit.messageHandlers[methodName].postMessage(
          paramA !== null ? paramA : "",
          paramB !== null ? paramB : ""
        );
      } else {
        return window.webkit.messageHandlers[methodName].postMessage(paramA !== null ? paramA : "");
      }
    }
  }
};
